import {PromotionDetailItem} from "../../domain/dtos/promotion-detail-item";

export class PromotionDetailItemMapper {
    static deserialize(param:  Record<string,any>): PromotionDetailItem {
        return {
            name: param.name,
            code: param.code,
            image: param.imageUrl,
            units: param.unitsBox,
            price: param.priceBox,
            quantity: param.quantity,
            unitPrice: param.priceUnit,
            priceWithoutPromo: param.priceBoxNoPromo ?? null,
            unitPriceWithoutPromo: param.priceUnitNoPromo ?? null,
        }
    }
}
